import { GraphQLClient } from 'graphql-request'
import { Cognito } from 'src/external/aws'
import { APPSYNC_ENDPOINT } from 'src/utils/env'
import { ExternalIdProvider, getSdk } from 'src/__generated__/backend/graphql'

const client = getSdk(new GraphQLClient(APPSYNC_ENDPOINT), async (action) => {
  const token = await Cognito.currentIdToken()
  return action({ Authorization: token })
})

export const linkFacebookAccount = (userId: string) =>
  client.LinkAccount({
    input: { provider: ExternalIdProvider.Facebook, userId },
  })

export const unlinkFacebookAccount = () =>
  client.UnlinkAccount({ input: { provider: ExternalIdProvider.Facebook } })

export const myAuthentication = client.Authentication
